import { createContext, useState, useMemo } from 'react';

const TabContext = createContext();

const TabProvider = ({ children }) => {
    /* TAB VARIABLES */
    const [activeTab, setActiveTab] = useState("Deals");
    const [selectedTab, setSelectedTab] = useState(null);

    /* DEAL VARIABLES */
    const [selectedDeal, setSelectedDeal] = useState(null);
    const [selectedPFI, setSelectedPFI] = useState(null);

    /* LINKED DEAL VARIABLES */
    const [selectedLinkedDeal, setSelectedLinkedDeal] = useState(null);
    const [selectedLinkedPFI, setSelectedLinkedPFI] = useState(null);

    /* TRANCHE VARIABLES */
    const [selectedTranche, setSelectedTranche] = useState(null);

    /* TRANCHE VARIABLES */
    const [isNewPFI, setIsNewPFI] = useState(false);

    const contextValue = useMemo(() => (
        {
            activeTab,
            selectedTab,
            selectedDeal,
            selectedLinkedDeal,
            selectedPFI,
            selectedLinkedPFI,
            isNewPFI,
            selectedTranche,
            setActiveTab,
            setSelectedTab,
            setSelectedDeal,
            setSelectedLinkedDeal,
            setSelectedPFI,
            setSelectedLinkedPFI,
            setSelectedTranche,
            setIsNewPFI
        }), [activeTab, selectedTab, selectedDeal, selectedLinkedDeal, selectedPFI, selectedLinkedPFI, selectedTranche, isNewPFI]);

    return (
        <TabContext.Provider value={contextValue}>
            {children}
        </TabContext.Provider>
    );
}

export { TabContext, TabProvider };